export default window.__litium.constants;

export const StockStatus = {
    Green: "Green",
    RedLow: "RedLow",
    RedMedium: "RedMed",
    RedHigh: "RedHigh",
    RedMax: "RedMax",
    RedHighest: "RedHighest",
    Yellow: "Yellow",
};

export const ShippingIntegrationType = {
    Inline: 'Inline',
    DeliveryCheckout: 'DeliveryCheckout',
    PaymentCheckout: 'PaymentCheckout',
};

export const PaymentIntegrationType = {
    IframeCheckout: 'IframeCheckout',
    PaymentWidgets: 'PaymentWidgets',
    DirectPayment: 'DirectPayment',
};
